import get from 'lodash/get';
import { ReviewState } from '../States';
import { ReviewTypes } from '../Types';
import { updateState } from '../Store';

export default function ReviewReducer(state = ReviewState, action) {
  switch (action.type) {
    case ReviewTypes.SET_ERROR:
      return { ...state, error: get(action, 'payload.error') };
    case ReviewTypes.SET_INFO:
      return { ...state, info: get(action, 'payload.info') };
    case ReviewTypes.SET_SUCCESS_MESSAGE:
      return { ...state, success: get(action, 'payload.success') };
    case ReviewTypes.RESET_ERROR:
      return { ...state, error: {} };
    case ReviewTypes.RESET_INFO:
      return { ...state, info: {} };
    case ReviewTypes.RESET_SUCCESS_MESSAGE:
      return { ...state, success: {} };
    case ReviewTypes.IS_API_PROGRESS:
      return {
        ...state,
        isAPIProgress: action.payload,
      };
    case ReviewTypes.TOGGLE_REVIEW:
      return updateState(state, { isReviewVisible: action.payload });
    case ReviewTypes.TOGGLE_ADD_REVIEW:
      return updateState(state, { isAddReviewVisible: action.payload });
    case ReviewTypes.IS_SUBMITTING_REVIEW:
      return updateState(state, { isSubmittingReview: action.payload });
    case ReviewTypes.IS_FETCHING_REVIEWS:
      return updateState(state, { isFetchingReviews: action.payload });
    case ReviewTypes.SET_REVIEWS:
      return updateState(state, { reviews: action.payload });
    case ReviewTypes.IS_SUBMITTING_VOTE:
      return updateState(state, { isSubmittingVote: action.payload });
    default:
      return state;
  }
}
